import React from "react";
import moment from "moment";
  
const TaskListTable = ({ tableData }) => {
  const getStatusBadgeColor = (status) => {
    switch (status) {
      case  "terminé":
        return "bg-green-100 text-green-600 border border-green-200";
      case "encours":
        return "bg-purple-100 text-purple-600 border border-purple-200";
      case "enattente":
        return "bg-cyan-100 text-cyan-600 border border-cyan-200";
        case "enretard":
        return "bg-red-100 text-red-600 border border-red-200";
      default:
        return "bg-gray-100 text-gray-600 border border-gray-200";
    }
  };

  const getPriorityBadgeColor = (priority) => {
    switch (priority) {
      case "élevé":
        return "bg-red-100 text-red-600 border border-red-200";
      case "moyen":
        return "bg-yellow-100 text-yellow-600 border border-yellow-200";
      case "faible":
        return "bg-green-100 text-green-600 border border-green-200";
      default:
        return "bg-gray-100 text-gray-600 border border-gray-200";
    }
  };

  return (
    <div className="overflow-x-auto p-0 rounded-lg mt-3 lg:w-[160vh]">
      <table className="w-full">
        <thead>
          <tr className="text-left">
            <th className="py-3 px-4 text-gray-800 font-medium text-[13px]">Nom</th>
            <th className="py-3 px-4 text-gray-800 font-medium text-[13px]">Status</th>
            <th className="py-3 px-4 text-gray-800 font-medium text-[13px]">Priorité</th>
            <th className="py-3 px-4 text-gray-800 font-medium text-[13px]">Date de création</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((task) => (
            <tr key={task._id} className="border-t  border-gray-200">
              <td className="my-3 mx-4 text-gray-700 text-[13px] line-clamp-1 overflow-hidden">{task.title}</td>
              <td className="py-3 px-4 text-gray-800 font-medium text-[13px]">
                <span
                  className={`px-2 py-1 text-xs rounded inline-block ${getStatusBadgeColor(
                    task.status
                  )}`}
                >
                  {task.status}
                </span>
              </td>
              <td className="py-4 px-4 ">
                <span
                  className={`px-2 py-1 text-xs rounded inline-block ${getPriorityBadgeColor(
                    task.priority
                  )}`}
                >
                  {task.priority}
                </span>
              </td>
              <td className="py-4 px-4 text-gray-700 text-[13px] text-nowrap hidden md:table-cell ">
                {task.createdAt
                  ? moment(task.createdAt).format("MMM Do, YYYY")
                  : "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskListTable;
